// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	// var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight - 20;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})


// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function ($) {
	if ($('.obj_image').length > 0) {
		objectFitImages('.obj_image');
	}
});


// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function ($) {
	if ($('.js-image-switch').length > 0) {
		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function () {
				var $this = $(this);
				if (windowWidth >= replaceWidth) {
					$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				imageSwitch();
			}, 200);
		});
	}
});


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.c-hamburger').length > 0) {
		$('.c-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is-open');
				nav.removeClass('is-close');
			} else {
				nav.removeClass('is-open');
				nav.addClass('is-close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.c-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is-open');
			nav.addClass('is-close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.c-hamburger:visible').length > 0) {
				$('.c-hamburger').click();
			}
		});
	}
});

// スライドの数 PC 3枚表示,TB 2枚表示,SP 1枚表示
// 表示枚数よりスライドがある場合、スライダーさせる
document.addEventListener("DOMContentLoaded", function () {
	const slideCount = document.querySelectorAll('.swiper-slide').length;

	function do_slider() {
		const defaultSlider = new Swiper(".js-defaultSlider .swiper", {
			speed: 1000,
			loop: true,
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
			},
			spaceBetween: 5,
			centeredSlides: true,

			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
					centeredSlides: false,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 40,
					centeredSlides: true,
				}
			},
			pagination: {
				el: '.js-defaultSlider .swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: ".js-defaultSlider .swiper-button-next",
				prevEl: ".js-defaultSlider .swiper-button-prev",
			},
		});
	}

	if (slideCount > 0) {
		if (window.matchMedia('(min-width: 1025px)').matches && slideCount > 3) {
			do_slider();
		} else if (window.matchMedia('(min-width: 769px) and (max-width: 1024px)').matches && slideCount > 2) {
			do_slider();
		} else if (window.matchMedia('(max-width: 768px)').matches && slideCount > 1) {
			do_slider();
		} else {
			document.querySelector(".js-defaultSlider .swiper-button-prev").remove();
			document.querySelector(".js-defaultSlider .swiper-button-next").remove();
		}
	}
});


// スライド表示1枚、2枚以上スライドがある場合、スライダーさせる
document.addEventListener("DOMContentLoaded", function () {
	const slideCount = document.querySelectorAll('.swiper-slide').length;

	function do_works_slider() {
		const defaultSlider = new Swiper(".js-worksSlider .swiper", {
			speed: 1000,
			loop: true,
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
			},
			centeredSlides: true,
			spaceBetween: 25,
			pagination: {
				el: '.js-worksSlider .swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: ".js-worksSlider .swiper-button-next",
				prevEl: ".js-worksSlider .swiper-button-prev",
			},

			breakpoints: {
				769: {
					spaceBetween: 0
				},
			},
		});
	}

	if (slideCount > 0) {
		if (slideCount > 1) {
			do_works_slider();
		} else {
			document.querySelector(".js-worksSlider .swiper-button-prev").remove();
			document.querySelector(".js-worksSlider .swiper-button-next").remove();
		}
	}
});